import Grid from '@mui/material/Grid';
//import Typography from '@mui/material/Typography';
import CardMarkerSmall from '../../../../../components/CockpitCards/CardMarkerSmall';
import DiaGetClockData from './DiaGetClockData';
import DiaClockInfo from './DiaClockInfo';
import DiseaseSubCard from './Disease/DiseaseSubCard';
import FitnessSubCard from './Fitness/FitnessSubCard';
import { useTheme } from "@mui/material";



export default function EpiRiskCard() {

  const theme = useTheme();
  
return(
<>

{theme.palette.mode === "light" ? (

<CardMarkerSmall

headline = "EPIGENETIC RISK STATUS" 
subtext = {"Your Rate of Aging will change based on your lifestyle interventions. Shorter telomere length and low telomerase activity are correlated with several chronic preventable diseases. Epigenetic fitness marker tell you how old you are according to your physical fitness and functionality." }
  

list = { <DiaGetClockData /> }
info = { <DiaClockInfo /> }

cardlines = {<>

<Grid container spacing={2}>

 <Grid size={12}><DiseaseSubCard /> </Grid>
 <Grid size={12}><FitnessSubCard /> </Grid>

</Grid>

</>}
/>  

) : (

  <CardMarkerSmall

headline = "BIO AGE" 
subtext = {"How old are you really? Biomarkers of aging and aging clocks are an essential part of aging research as aging is recognized as a fundamental driver of chronic diseases and mortality. Aging clocks are relatively new but groundbreaking in the aging science. Clocks not only tell you how old you really are (biological age versus chronological age), but also serve as monitor for the effectiveness of interventions in the aging process and preventive treatments for age-related diseases." }
  

list = { <DiaGetClockData /> }
info = { <DiaClockInfo /> }

cardlines = {<>

<Grid container spacing={2}>

 <Grid size={12}><DiseaseSubCard /> </Grid>
 <Grid size={12}><FitnessSubCard /> </Grid>

</Grid>


</>}
/>  

)}

</>
)
}

